import styled, { css } from 'styled-components/macro';
import { colorBlackTransparent50, colorCoreBlack900Base, colorCoreGray500, colorCoreWhite1000, colorCoreGray1000Base, } from '@yme/tokens/colors';
function getMarginSize({ isSelectorBigSize, paddingSize, }) {
    return isSelectorBigSize
        ? `calc(10px - ${paddingSize}px)` // 10px-5px=5px
        : `calc(6px - ${paddingSize}px)`; // 6px-3px=3px
}
export const ColorSelectorStyled = styled.div `
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  --margin-option: ${({ isSelectorBigSize, paddingSize }) => getMarginSize({
    isSelectorBigSize,
    paddingSize,
})};

  gap: var(--margin-option);
`;
export const SVGIconStyled = styled.div `
  cursor: pointer;
  background-color: transparent;
  align-items: center;
  border-radius: 50%;
  border-width: 1px;
  border-style: solid;
  border-color: transparent;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;

  --common-size: ${({ size, paddingSize }) => `calc(${size}px + (${paddingSize}px + 1px) * 2)`};

  padding: ${({ paddingSize }) => `${paddingSize}px`};

  width: var(--common-size);
  height: var(--common-size);

  transition: border-color 50ms, background-color 50ms ease-out 120ms;

  &:hover {
    background-color: ${colorBlackTransparent50};
    cursor: pointer;
  }

  ${({ isActive }) => isActive &&
    css `
      border-color: ${colorCoreBlack900Base};
      background-color: ${colorBlackTransparent50};
    `}

  span {
    border-radius: 50%;
    border: 1px solid ${colorCoreGray500};

    ${({ size, colourCode, isActive }) => !isActive &&
    colourCode?.toLowerCase() === colorCoreWhite1000.toLowerCase() &&
    css `
        border-radius: 50%;
        box-sizing: border-box;
        border: 1px solid ${colorCoreGray1000Base};
        width: ${`${size + 1}px`};
        height: ${`${size + 1}px`};
      `}
  }
`;
